export const getPlayIconPosition = (aspectRatio, isCustomWebsite) => {
  if (isCustomWebsite && aspectRatio < 100) return '30%';
  return '50%';
};

export const getImageDimensions = (aspectRatio) => {
  const imageDimensionsObj = {
    width: '480px',
    height: '480px',
  };

  return imageDimensionsObj;
};

export const getThumbnailImageDimensions = (aspectRatio) => {
  const imageDimensionsObj = {
    height: '48px',
    width: '48px',
  };

  return imageDimensionsObj;
};

export const getEnlargedImageContainerDimensions = (aspectRatio) => {
  const imageDimensionsObj = {
    height: '100%',
    width: '100%',
  };

  return imageDimensionsObj;
};

export const getZoomedImageDimension = (aspectRatio) => {
  const imageDimensionsObj = {
    width: 1000,
    height: 1000,
  };
  if (aspectRatio > 100) {
    imageDimensionsObj.width = 1000;
    imageDimensionsObj.height = 560;
  }
  if (aspectRatio < 100) {
    imageDimensionsObj.width = 1000;
    imageDimensionsObj.height = 1800;
  }
  return imageDimensionsObj;
};
